module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/sagar-59fd0f28f0715848794254d2590d5016.mp3";